import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
    getLegalRank,
    getTableColumnNames,
    addLegalRank as postLegalRank,
    updateLegalRank as putLegalRank,
    deleteLegalRank as removeLegalRank,
    activateDeactivateLegalRank as activateLegalRank
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Legal Rank Table Column Names
export const fetchLegalRankTableColumnNames = createAsyncThunk(
  "legalRank/fetchLegalRankTableColumnNames",
  async (legalRank, thunkAPI) => {
    try {
      const response = await getTableColumnNames(legalRank);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Legal Rank
export const fetchLegalRank = createAsyncThunk(
  "legalRank/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getLegalRank();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching legal rank");
    }
  }
);

// Add Legal Rank
export const addLegalRank = createAsyncThunk(
  "legalRank/add",
  async (legalRank, { rejectWithValue }) => {
    try {
      const response = await postLegalRank(legalRank);
        toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error adding human category");
    }
  }
);

// Update Legal Rank
export const updateLegalRank = createAsyncThunk(
  "legalRank/update",
  async (legalRank, { rejectWithValue }) => {
    try {
      const response = await putLegalRank(legalRank);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error updating human category");
    }
  }
);

// Delete Legal Rank
export const deleteLegalRank = createAsyncThunk(
  "legalRank/delete",
  async (legalRank, { rejectWithValue }) => {
    try {
      const response = await removeLegalRank(legalRank);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error deleting human category");
    }
  }
);

// Active Deactive Legal Rank
export const activateDeactivateLegalRank = createAsyncThunk(
  "legalRank/activateDeactivate",
  async (legalRank, { rejectWithValue }) => {
    try {
      const response = await activateLegalRank(legalRank);      
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error activating/deactivating human category");
    }
  }
);